import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AssetForm from './components/AssetForm';
import ProcessingStatus from './components/ProcessingStatus';
import SuccessView from './components/SuccessView';
import CheckStatus from './components/CheckStatus';
import Header from './components/Header'; // Importamos el encabezado reutilizable
import './App.css';

function App() {
  const [jobId, setJobId] = useState(null);
  const [status, setStatus] = useState(null);
  const [sharePointUrl, setSharePointUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const resetForm = () => {
    setJobId(null);
    setStatus(null);
    setSharePointUrl(null);
    setLoading(false);
    setError(null);
  };

  return (
      <Router>
        <div className="bg-light min-vh-100 py-5">
          <div className="container">
            {/* Encabezado común para todas las rutas */}
            <Header />
            {/* Definición de rutas */}
            <Routes>
              {/* Ruta principal */}
              <Route
                  path="/"
                  element={
                    <div className="row justify-content-center">
                      <div className="col-md-8">
                        <div className="card shadow-sm">
                          <div className="card-body">
                            {!jobId ? (
                                <AssetForm
                                    setJobId={setJobId}
                                    setLoading={setLoading}
                                    setError={setError}
                                />
                            ) : !sharePointUrl ? (
                                <ProcessingStatus
                                    jobId={jobId}
                                    status={status}
                                    setStatus={setStatus}
                                    setSharePointUrl={setSharePointUrl}
                                    loading={loading}
                                    setLoading={setLoading}
                                    error={error}
                                    setError={setError}
                                />
                            ) : (
                                <SuccessView
                                    sharePointUrl={sharePointUrl}
                                    resetForm={resetForm}
                                />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  }
              />
              {/* Ruta para verificar el estado */}
              <Route path="/check-job-status" element={<CheckStatus />} />
            </Routes>
          </div>
        </div>
      </Router>
  );
}

export default App;